import { Button, ButtonRow, FormSection, Text } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { getSelectedLanguage } from '@frontend/translate';

export function AccountRequestWrongApproverView() {
    const translate = getSelectedLanguage();
    const navigate = useNavigate();

    return (
        <>
            <FormSection isBorderless>
                <Text>{translate.accountRequest.wrongApproverDescription}</Text>
            </FormSection>
            <FormSection
                isBorderless
                sx={{ marginTop: [11, 14] }}
            >
                <ButtonRow>
                    <Button
                        onClick={() => navigate('/home')}
                        width="full"
                    >
                        {translate.accountRequest.openTheKsyosPlatform}
                    </Button>
                </ButtonRow>
            </FormSection>
        </>
    );
}
